import { Observable, Subject } from 'rxjs';
import { filter, map, mergeMap, shareReplay, startWith, takeUntil, tap } from 'rxjs/operators';

const camelcaseKeys = require('camelcase-keys');

export function camelCase<T>(deep = true) {
  return (s: Observable<T>) => s.pipe(map(obj => camelcaseKeys(obj, { deep })));
}

export function keepUpdater<T>() {
  let lastValue: any;
  return (s: Observable<T>) => s.pipe(
    shareReplay(1),
    filter((v) => v !== lastValue),
    tap((v) => {
      lastValue = v;
    })
  );
}

export function cacheMap<T, V>(exec: (t: T) => Observable<V>) {
  const init = {} as any;
  let cacheValue = init;
  return (s: Observable<T>) => s.pipe(
    mergeMap((t) => {
      return cacheValue === init ? exec(t) : exec(t).pipe(startWith(cacheValue));
    }),
    tap((v) => {
      cacheValue = v;
    })
  );
}

export function unsubscribeLater<T>(time: number, exec?: () => void) {
  const destroy = new Subject();
  return (s: Observable<T>) => s.pipe(
    takeUntil(destroy),
    tap(() => {
      setTimeout(() => {
        destroy.next();
        destroy.complete();
        if (exec) {
          exec();
        }
      }, time);
    }),
  );
}
